import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../../services/auth.service';

export const authHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getAccessToken();
  const isApi = req.url.includes('/api/');

  const nextReq =
    token && isApi
      ? req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        })
      : req.clone({ withCredentials: isApi || req.withCredentials });

  return next(nextReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && isApi) {
        const onProtectedRoute =
          router.url.startsWith('/platform') || router.url.startsWith('/tenant');
        if (onProtectedRoute && !router.url.startsWith('/auth/login')) {
          authService.clearSession();
          void router.navigateByUrl('/auth/login');
        }
      }

      return throwError(() => error);
    }),
  );
};
